import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getTransferQuestions,
  setTransferQuestions,
  ISetTransferQuestionsBody,
  ITransferQuestionsPayload,
} from '../services/transferQuestions'; // Trying relative path

const TRANSFER_QUESTIONS_QUERY_KEY = 'transferQuestions';

export const useGetTransferQuestions = (chatToken: string | undefined) => {
  return useQuery<ITransferQuestionsPayload, Error>({
    // Ensure the query key is unique and includes dependencies
    queryKey: [TRANSFER_QUESTIONS_QUERY_KEY, chatToken],
    queryFn: () => getTransferQuestions(chatToken!),
    // Only run the query if chatToken is defined and not empty
    enabled: !!chatToken,
  });
};

export const useSetTransferQuestions = () => {
  const queryClient = useQueryClient();

  return useMutation<{ success: boolean }, Error, ISetTransferQuestionsBody>({
    mutationFn: setTransferQuestions,
    onSuccess: (data, variables) => {
      // Invalidate and refetch the questions list after successful mutation
      // Ensure the query key matches the one used in useGetTransferQuestions
      queryClient.invalidateQueries({
        queryKey: [TRANSFER_QUESTIONS_QUERY_KEY, variables.chat_token],
      });
    },
    // onError can be handled here or relies on the global handler in the service
  });
};
